import Vue from "vue";

export const CalendarState = {
  myCalendar: [],
  mySessions: [],
  totalMySessions: 0
};

export const CalendarGetters = {
  myCalendar: state => {
    return state.myCalendar;
  },
  mySessions: state => {
    return state.mySessions;
  },
  totalMySessions: state => {
    return state.totalMySessions;
  }
};

export const CalendarMutations = {
  setMyCalendar: (state, data) => {
    const arr = [];
    for (const key in data) {
      const date = key;
      arr.push({ date, timeslots: data[key] });
    }
    Vue.set(state, "myCalendar", arr);
  },
  setMySessions: (state, data) => {
    Vue.set(state, "mySessions", data.appointments);
    Vue.set(state, "totalMySessions", data.total_count);
  }
};

export const CalendarActions = {
  /*
    { view: calendar }
  */
  getMySessions: ({ commit, dispatch }, data = {}) => {
    const params = data.params || "";
    return Vue.axios.secured
      .get(`/api/v1/users/my_sessions${params}`)
      .then(response => {
        if (params.includes("view=calendar")) {
          commit("setMyCalendar", response.data);
        } else {
          commit("setMySessions", response.data);
        }
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to fetch my sessions from server.";
        dispatch("showToast", { message, type: "error" });
      });
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/calendar.store.js